import React from 'react';
import { CapitalMarketsPage } from './components/CapitalMarkets/CapitalMarketsPage';
export function App() {
  return <div className="w-full min-h-screen bg-background text-foreground" data-id="element-0">
      <CapitalMarketsPage data-id="element-1" />
    </div>;
}